import {
  Box,
  Flex,
  Heading,
  Text,
  Image,
  List,
  ListItem,
  ListIcon,
} from "@chakra-ui/react";
import React, { useEffect, useContext } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { themeContext } from "../Context";
import { CheckCircleIcon } from "@chakra-ui/icons";

export const ProfessionalExperiance = () => {
  useEffect(() => {
    AOS.init({ delay: 300 });
  }, []);

  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <Box textAlign={"center"} id="experience" boxSizing="border-box" paddingBottom={'10%'}   paddingTop={{ base: "60px", md: "80px" }} >
      <Heading
        mt="60px"
        display={"inline-block"}
        padding="10px"
        data-aos="fade-right"
        mb="45px"
        textAlign={"center"}
        size="2xl"
        as="h1"
        fontFamily="initial"
      >
        Professional <span style={{ color: "#FCA61F" }}>Experience</span>
      </Heading>

      <Flex
        justifyContent="space-around"
        fontFamily="initial"
        direction={{ base: "column", lg: "row" }}
        alignItems="center"
        gap="30px"
      >
        <Box
          w={{ base: "90%", lg: "40%" }}
          data-aos="zoom-out"
          rounded="md"
          overflow="hidden"
          boxShadow="lg"
        >
          <Image
            w="100%"
            border={"1px inset"}
            boxShadow="dark-md"
            p="6"
            rounded="md"
            src={
              darkMode
                ? "https://res.cloudinary.com/practicaldev/image/fetch/s--xq8xxUmL--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://external-preview.redd.it/x7vVnP3L75Wh4ApmXedKjze9b7ZuH5h7oW-4xbHMiHQ.jpg%3Fauto%3Dwebp%26s%3Db7d6873eed8c442bb685a083b3b4bfff6dd009ac"
                : "https://i.postimg.cc/tgPXsFbP/s.avif"
            }
            borderRadius="10px"
            alt="Professional Experience"
          />
        </Box>

        <Box w={{ base: "90%", lg: "50%" }} data-aos="fade-left" textAlign="left">
          <Heading as="h3" fontSize="2xl" mb="4" color="#FCA61F" fontFamily="initial">
            STOQ Club
          </Heading>
          <Text fontSize="lg" mb="4" color={darkMode ? "white" : "black"}>
            <strong>
              Web <span style={{ color: "#FCA61F" }}>Developer</span>
            </strong>{" "}
            | August 2024 – <span style={{ color: "#FCA61F" }}>Present</span> | Mumbai, {" "}
            <span style={{ color: "#FCA61F" }}>India</span>
          </Text>
          <List spacing={3} fontSize="md" color={darkMode ? "white" : "#788097"}>
            <ListItem>
              <ListIcon as={CheckCircleIcon} color="#FCA61F" />
              Developed and deployed a platform supporting multiple user roles: Research Analyst, Research Head, Dealer, Admin, and Clients.
            </ListItem>
            <ListItem>
              <ListIcon as={CheckCircleIcon} color="#FCA61F" />
              Created role-based dashboards for investment tracking, approvals, and trade execution, improving user workflow.
            </ListItem>
            <ListItem>
              <ListIcon as={CheckCircleIcon} color="#FCA61F" />
              Built a seamless approval system for Research Heads to review and manage investment baskets efficiently.
            </ListItem>
            <ListItem>
              <ListIcon as={CheckCircleIcon} color="#FCA61F" />
              Designed a Dealer module enabling real-time trade execution and client portfolio tracking.
            </ListItem>
            <ListItem>
              <ListIcon as={CheckCircleIcon} color="#FCA61F" />
              Implemented a secure authentication system with OTP-based login and temporary lockout after failed attempts.
            </ListItem>
            <ListItem>
              <ListIcon as={CheckCircleIcon} color="#FCA61F" />
              Developed a fully responsive client application with real-time profit/loss visualization and investment insights.
            </ListItem>
            <ListItem>
              <ListIcon as={CheckCircleIcon} color="#FCA61F" />
              Built reusable UI components and maintained a scalable folder structure to streamline future development.
            </ListItem>
          </List>
        </Box>
      </Flex>
    </Box>
  );
};
